import React from "react";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import HeroSection from "../../components/HeroSection/HeroSection";
import HeroCaption from "../../components/HeroCaption/HeroCaption";
import NIISEventsResponsive from "../../components/NIISEventsResponsive/NIISEventsResponsive";

const NIISEventsPage = () => {
  return (
    <PageWrapper className="mt-n6">
      <HeroSection className="bg-page-background-dream-fest">
        <HeroCaption
          title="NIIS Events"
          position="bottom-left"
          breadcrumb={true}
          breadcrumbPrefix="Home"
        />
      </HeroSection>
      <NIISEventsResponsive />
    </PageWrapper>
  );
};

export default NIISEventsPage;
